import { render, staticRenderFns } from "./gift_wall.vue?vue&type=template&id=2531afc5&scoped=true"
import script from "./gift_wall.vue?vue&type=script&lang=ts"
export * from "./gift_wall.vue?vue&type=script&lang=ts"
import style0 from "./gift_wall.vue?vue&type=style&index=0&id=2531afc5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2531afc5",
  null
  
)

export default component.exports